<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Map Type:">
              <b-v-select
                v-model="formFilters.zoneLookupMapType"
                :searchable="true"
                :options="mapTypeFilter"
              />
            </b-form-group>
            <b-form-group label="Carrier:">
              <b-form-input v-model="formFilters.carrier" />
            </b-form-group>
            <b-form-group label="Service:">
              <b-form-input v-model="formFilters.service" />
            </b-form-group>
            <b-form-group label="From Warehouse:">
              <b-v-select
                v-model="formFilters.fromWarehouseId"
                :searchable="true"
                :options="warehousesFilter"
              />
            </b-form-group>
            <b-form-group label="Country Code:">
              <b-form-input v-model="formFilters.countryCode" />
            </b-form-group>
            <b-form-group label="Post Code:">
              <b-form-input v-model="formFilters.postCode" />
            </b-form-group>
            <b-form-group label="Maps To Zone ID:">
              <b-form-input v-model="formFilters.mapsToZoneId" />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Config: Zone Lookup Card Items
            </h1>
            <ActiveFiltersCard :itemsFilters="itemsFilters" :resetFilterWithKey="resetFilterWithKey" :loadItems="loadItems">
              <template v-slot:filterVal(fromWarehouseId)="data">
                <span
                  v-if="myWarehouses && myWarehouses.find(a => a.id == data.item)"
                  >{{ myWarehouses.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:filterVal(zoneLookupMapType)="data">
                <span v-if="data.item">{{ data.item }}</span>
                <span v-else>-</span>
              </template>
            </ActiveFiltersCard>
          </div>
          <div class="col-auto">
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(createDateTimeUtc)="data">
        <span
          v-if="
            data.item.createDateTimeUtc &&
              !data.item.createDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.createDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.createDateTimeUtc">{{
          data.item.createDateTimeUtc | moment('MMM Do YY, h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(zoneLookupMapType)="data">
        <span class="badge badge-primary" v-if="data.item.zoneLookupMapType == 'MapByCountryCode'">Map By Country Code</span>
        <span class="badge badge-info" v-else-if="data.item.zoneLookupMapType == 'MapByPostCode'">Map By Post Code</span>
        <span class="badge badge-warning" v-else-if="data.item.zoneLookupMapType == 'MapByPostCodeRange'">Map By Post Code Range</span>
        <span class="badge badge-secondary" v-else>{{ data.item.zoneLookupMapType }}</span>
      </template>
      <template v-slot:cell(fromWarehouseName)="data">
        <span v-if="data.item.fromWarehouseName">{{ data.item.fromWarehouseName }}</span>
        <span v-else class="text-muted">-</span>
      </template>
      <template v-slot:cell(postCodeRange)="data">
        <span v-if="data.item.postCode">{{ data.item.postCode }}</span>
        <span v-if="data.item.postCodeRangeFrom && data.item.postCodeRangeTo">
          {{ data.item.postCodeRangeFrom }} - {{ data.item.postCodeRangeTo }}
        </span>
        <span v-else class="text-muted">-</span>
      </template>
      <template v-slot:cell(mapsToZoneId)="data">
        <span class="badge badge-success">{{ data.item.mapsToZoneId }}</span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import ActiveFiltersCard from '@/views/components/ActiveFiltersCard.vue';
import TableListing from '@/views/components/TableListing.vue';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';

export default {
  name: 'Billing.ZoneLookupCardItems.Index',
  mixins: [crudMixinGen('billing/zoneLookupCardItems'), myCommonDataMixin],
  components: {
    ActiveFiltersCard,
    TableListing
  },
  computed: {
  },

  data: () => ({
    mapTypeFilter: [
      {value: 'MapByCountryCode', text: 'Map By Country Code'},
      {value: 'MapByPostCode', text: 'Map By Post Code'},
      {value: 'MapByPostCodeRange', text: 'Map By Post Code Range'}
    ],
    fields: [
      { key: 'zoneLookupMapType', label: 'Map Type', sortable: false },
      { key: 'carrier', label: 'Carrier', sortable: false },
      { key: 'service', label: 'Service', sortable: false },
      { key: 'fromWarehouseName', label: 'From Warehouse', sortable: false },
      { key: 'countryCode', label: 'Country Code', sortable: false },
      { key: 'postCodeRange', label: 'Postcode / Range', sortable: false },
      { key: 'mapsToZoneId', label: 'Maps To Zone', sortable: false },
      { key: 'createDateTimeUtc', label: 'Created', sortable: false }
    ]
  }),
  mounted() {
    let queryHas = this.$route.query;
    if (queryHas) {
      this.resetFormFilters();
      this.formFilters = Object.assign(this.itemsFilters, queryHas);
      this.itemsFilters = Object.assign(this.itemsFilters, queryHas);
    } else {
      this.resetFormFilters();
    }
    this.loadItems();
  },

  methods: {
  }
};
</script>